export function logInfo(message: string, data?: any) {
    data ? console.info(message, data) : console.info(message);
}
